import React, { useEffect, useState } from 'react';
import useViewPort from '../Hooks/useViewPort';

import './NavBar.scss';

const NavBar = ({ productPosition }) => {
  const [navScroll, setNavScroll] = useState(false);
  const [subNavToggle, setSubNavToggle] = useState(false);
  const [subNavToggleCN, setSubNavToggleCN] = useState(false);
  const [mobileNavToggle, setMobileToggle] = useState(false);
  const [mobileNavToggleCN, setMobileToggleCN] = useState(false);
  const [productSubMenu, setProductSubMenu] = useState(false);
  const [productSubMenuCN, setProductSubMenuCN] = useState(false);
  const { width } = useViewPort();

  useEffect(() => {
    document.addEventListener('scroll', () => {
      if (window.scrollY > 80) {
        setNavScroll(false);
      } else {
        setNavScroll(true);
      }
    });
  });

  useEffect(() => {
    if (
      productPosition === 'Technology' ||
      productPosition === 'Design' ||
      productPosition === 'Quality' ||
      productPosition === 'Case' ||
      productPosition === 'Spec'
    ) {
      setSubNavToggle(true);
      setSubNavToggleCN(true);
    } else {
      setSubNavToggleCN(false);
      setTimeout(() => {
        setSubNavToggle(false);
      }, 500);
    }
  }, [productPosition]);

  const handleMobileNav = action => {
    if (action === 'close') {
      setMobileToggleCN(false);
      setProductSubMenuCN(false);
      setTimeout(() => {
        setMobileToggle(false);
        setProductSubMenu(false);
      }, 500);
    } else {
      setMobileToggle(true);
      setMobileToggleCN(true);
    }
  };

  const handleProductSubNav = () => {
    if (productSubMenu) {
      setProductSubMenuCN(false);
      setTimeout(() => {
        setProductSubMenu(false);
      }, 500);
    } else {
      setProductSubMenuCN(true);
      setProductSubMenu(true);
    }
  };

  return (
    <div className={navScroll ? 'navBar' : 'navBar active'}>
      {width > 990 ? (
        <>
          <div className="mainNav">
            <div className="navBarLeft">
              <a href="/">
                <img
                  className="CompanylogoNav"
                  src="/images/NSW-Logo3.png"
                  alt="logo"
                />
              </a>
            </div>
            <div className="navBarMid">
              <div>
                <a href="#first">Home</a>
              </div>
              <div>
                <a href="#second">About</a>
              </div>
              <div>
                <a href="#third">Product</a>
              </div>
              <div>
                <a href="#fourth">FAQ</a>
              </div>
              <div>
                <a href="#fifth">Store</a>
              </div>
              <div>
                <a href="#sixth">Contact</a>
              </div>
            </div>
          </div>

          {subNavToggle && (
            <div className={subNavToggleCN ? 'subNav' : 'subNav close'}>
              <div
                className={
                  productPosition === 'Technology' ? 'subActive' : null
                }
              >
                <a href="#Technology">Technology</a>
              </div>
              <div
                className={productPosition === 'Design' ? 'subActive' : null}
              >
                <a href="#Design">Design</a>
              </div>
              <div
                className={productPosition === 'Quality' ? 'subActive' : null}
              >
                <a href="#Quality">Quality</a>
              </div>
              <div className={productPosition === 'Case' ? 'subActive' : null}>
                <a href="#Case">Case</a>
              </div>
              <div className={productPosition === 'Spec' ? 'subActive' : null}>
                <a href="#Spec">Spec</a>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="mobileNav">
          <div className="navBarLeft">
            <a href="/">
              <img
                className="CompanylogoNav"
                src="/images/NSW-Logo3.png"
                alt="logo"
              />
            </a>
          </div>
          <div
            className="navBarRightImg"
            onClick={() => handleMobileNav('open')}
          >
            <img
              className={navScroll ? 'navBarRightImgOn' : 'navBarRightImgClose'}
              src="/images/bars-solid.svg"
              alt="img"
            />
          </div>
          {mobileNavToggle && (
            <div>
              <div
                className={
                  mobileNavToggleCN
                    ? 'mobileNavBackGround'
                    : 'mobileNavBackGround close'
                }
                onClick={() => handleMobileNav('close')}
              />
              <div
                className={
                  mobileNavToggleCN ? 'mobileNavMain' : 'mobileNavMain close'
                }
              >
                <div className="moblieNavClose">
                  <img
                    src="/images/xmark-solid.svg"
                    alt="close"
                    onClick={() => handleMobileNav('close')}
                  />
                </div>

                <div
                  onClick={() => handleMobileNav('close')}
                  className="mobileNavMainMenu"
                >
                  <a href="#first">Home</a>
                </div>
                <div
                  onClick={() => handleMobileNav('close')}
                  className="mobileNavMainMenu"
                >
                  <a href="#second">About</a>
                </div>
                <div
                  onClick={handleProductSubNav}
                  className="mobileNavMainMenu mobileproduct"
                >
                  <a href="#third">Product</a>
                  {productSubMenu && (
                    <div
                      className={
                        productSubMenuCN
                          ? 'mobileNavMainSubTotal'
                          : 'mobileNavMainSubTotal close'
                      }
                    >
                      <div
                        onClick={() => handleMobileNav('close')}
                        className="mobileNavMainSub"
                      >
                        <a href="#Technology">Technology</a>
                      </div>
                      <div
                        onClick={() => handleMobileNav('close')}
                        className="mobileNavMainSub"
                      >
                        <a href="#Design">Design</a>
                      </div>
                      <div
                        onClick={() => handleMobileNav('close')}
                        className="mobileNavMainSub"
                      >
                        <a href="#Quality">Quality</a>
                      </div>
                      <div
                        onClick={() => handleMobileNav('close')}
                        className="mobileNavMainSub"
                      >
                        <a href="#Case">Case</a>
                      </div>
                      <div
                        onClick={() => handleMobileNav('close')}
                        className="mobileNavMainSub"
                      >
                        <a href="#Spec">Spec</a>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  onClick={() => handleMobileNav('close')}
                  className="mobileNavMainMenu"
                >
                  <a href="#fourth">FAQ</a>
                </div>
                <div
                  onClick={() => handleMobileNav('close')}
                  className="mobileNavMainMenu"
                >
                  <a href="#fifth">Store</a>
                </div>
                <div
                  onClick={() => handleMobileNav('close')}
                  className="mobileNavMainMenu"
                >
                  <a href="#sixth">Contact</a>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NavBar;
